@if (isForbidLoading || isWithdrawForbid) {
  <deposit-withdraw-forbid [isLoading]="isForbidLoading"></deposit-withdraw-forbid>
} @else {
  <div class="scroll-cont">
    <div class="section">
      @if (!isConnected) {
        <div class="cont">
          <div class="title">Connect your Web3 wallet to Pubs for instant crypto deposits</div>
          <app-third-auth-m8 type="wallet" [isRegLogPage]="false"></app-third-auth-m8>
          @if (!isTgApp) {
            <cs-button
              color="accent"
              size="large"
              label="Connect your wallet"
              (buttonClick)="
                this.thirdAuthM8Service.handleAuth({
                  authName: ThirdAuthUser.WalletConnect,
                  isRegLogPage: false,
                })
              "
            ></cs-button>
          }
        </div>
      } @else {
        <div class="cont">
          <div class="row">
            <!-- 選擇幣別 -->
            <div class="item">
              <div class="label">
                <span>Select currency</span>
              </div>
              <cs-select
                [(value)]="selectedCurrencyOption"
                [options]="currencyOptions"
                (valueChange)="onCurrencySelectChange()"
              ></cs-select>
            </div>
            <!-- 選擇網路 -->
            <div class="item">
              <div class="label">
                <span>Select network</span>
              </div>
              <cs-select
                [(value)]="selectedNetworkOption"
                [options]="networkOptions"
                (valueChange)="onNetworkSelectChange()"
              ></cs-select>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-input
                [label]="'From'"
                [readonly]="true"
                value="PUBS Wallet"
                prefixImgUrl="/assets/images/login-wallets/pubs.svg"
                [marginBottom]="'0'"
              />
              <div class="msg">{{ currentBalance | currencyValue: currentCurrency }}{{ currentCurrency }}</div>
            </div>

            <cs-button
              (buttonClick)="walletService.jump('deposit', 'web3wallet')"
              [iconLeft]="'fi-switch-horizontal-filled'"
              [iconType]="'icon'"
              [color]="'secondary'"
              [size]="'default'"
              [width]="'38px'"
              [height]="'38px'"
            ></cs-button>
            <div class="item">
              <cs-input
                [label]="'To'"
                [readonly]="true"
                [value]="currentWeb3Wallet | web3WalletName"
                prefixImgUrl="/assets/images/login-wallets/{{ currentWeb3Wallet.toLocaleLowerCase() }}.svg"
                [marginBottom]="'0'"
              />
              <div class="msg">
                @if (!isHideWeb3Currency) {
                  {{ currentWeb3WalletBalance | currencyValue: currentCurrency }}{{ currentCurrency }}
                }
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-input
                [label]="'Withdrawal Amount'"
                [inputMode]="'decimal'"
                [suffixText]="'Max'"
                [marginBottom]="'0'"
                (suffixIconClick)="onSetWithdrawMaxAmount()"
                [(value)]="amount"
                [hasError]="!amountValid"
                [errorHint]="errText"
                [max]="getWithdrawMaxAmount()"
                (valueChange)="onAmountInput()"
                [disabled]="!selectedNetworkOption || !selectedCurrencyOption"
                input-float
              />
              <div class="msg big-msg">
                Available balance is <span>{{ coinLimitData?.availQuota || 0 | currencyValue: currentCurrency }}</span
                ><span>{{ currentCurrency }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="item">
              <cs-button
                color="accent"
                size="large"
                label="Withdraw"
                (buttonClick)="onWeb3Withdraw()"
                [loading]="isAllLoading()"
                [disabled]="!isReadyToWithdraw()"
              ></cs-button>
              @if (selectedNetworkOption) {
                <div class="confirm-note-list">
                  <div class="confirm-note-item">
                    <i class="icon" class="fi-exclamation-circle-filled"></i>
                    <p>
                      Your
                      <span class="mark"> {{ currentCurrency }} </span>
                      withdrawal will be sent via the
                      <span class="mark"> {{ selectedNetworkOption.desc }} </span>
                      network
                    </p>
                  </div>
                  @if (selectedNetworkOption.withdrawFee.add(fee) > 0) {
                    <div class="confirm-note-item">
                      <i class="icon" class="fi-exclamation-circle-filled"></i>
                      <p>
                        A fee of
                        <span class="mark">
                          {{ selectedNetworkOption.withdrawFee.add(fee) | currencyValue: currentCurrency }}
                          {{ currentCurrency }}
                        </span>
                        will be applied
                      </p>
                    </div>
                  }
                  <div class="confirm-note-item">
                    <i class="icon" class="fi-exclamation-circle-filled"></i>
                    <p>
                      The minimum withdrawal amount is
                      <span class="mark">
                        {{ selectedNetworkOption.minAmount | number: '1.0-20' }} {{ currentCurrency }}
                      </span>
                    </p>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div class="note">
        <span>Don’t have a wallet?</span>
        <cs-button
          (buttonClick)="walletService.jump('withdraw', 'transfer')"
          color="secondary"
          width="auto"
          size="small"
          label="Transfer to crypto address"
        ></cs-button>
      </div>
    </div>
  </div>
}
